// Decorative gold line-art floral corner flourish
export default function Flourish({ className = "", flip = false }) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      className={className}
      style={{ transform: flip ? "scaleX(-1)" : undefined }}
      aria-hidden="true"
    >
      <g stroke="#C5A059" strokeWidth="1" opacity="0.55" fill="none">
        <path d="M2 2 C 40 20, 60 55, 55 95 C 52 120, 30 140, 8 150" />
        <path d="M2 2 C 20 40, 55 60, 95 55 C 120 52, 140 30, 150 8" />
        <path d="M55 95 C 75 90, 95 70, 95 55" opacity="0.7" />
        <circle cx="70" cy="70" r="26" opacity="0.6" />
        <path d="M70 44 C 82 52, 82 88, 70 96 C 58 88, 58 52, 70 44" opacity="0.7" />
        <path d="M44 70 C 52 58, 88 58, 96 70 C 88 82, 52 82, 44 70" opacity="0.7" />
        <path d="M52 52 C 62 62, 78 62, 88 52" opacity="0.5" />
        <path d="M52 88 C 62 78, 78 78, 88 88" opacity="0.5" />
        <circle cx="70" cy="70" r="5" opacity="0.9" />
        <path d="M120 20 q 15 8 18 26" opacity="0.5" />
        <path d="M20 120 q 8 15 26 18" opacity="0.5" />
      </g>
    </svg>
  );
}
